import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface BackgroundPageContentProps {
  className?: string
  noStackingIndex?: boolean
}

const BlankBackgroundPageContent: React.FC<
  React.PropsWithChildren<BackgroundPageContentProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        ${!props.noStackingIndex &&
        css`
          z-index: 0;
        `}
        height: 100%;
        padding: 20px ${styleConstants.widths.headerPaddingXLGUp};

        ${getBreakpointOnly(breakpointSizes.LG)(css`
          padding: 20px ${styleConstants.widths.headerPaddingLGOnly};
        `)}

        ${getBreakpointOnly(breakpointSizes.MD)(css`
          padding: 20px ${styleConstants.widths.headerPaddingMDOnly};
        `)}
        
        ${getBreakpointOnly(breakpointSizes.SM)(css`
          padding: 20px ${styleConstants.widths.headerPaddingSMOnly};
        `)}

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          padding: 20px 12px;
        `)}
      `}
    >
      {props.children}
    </div>
  )
}

export default BlankBackgroundPageContent
